<template>
    <Head>
        <title>Партнеры</title>
    </Head>

    <authenticated-layout :notifications="notifications" >


        <div class="grid grid-cols-3 p-6 gap-6">

            <div class="flex flex-col p-6 gap-2 bg-white rounded">
                <v-input label="Название" v-model="result.name"/>
                <v-input label="Email" v-model="result.email"/>
                <v-input label="Хост" v-model="result.host"/>
                <v-input label="Публичный ключ" v-model="result.publicKey"/>
                <v-input label="Приватный ключ" v-model="result.privateKey"/>
                <v-toggle label-left="Пополнение" size="sm" v-model="result.allowBalanceReplenishment"/>
            </div>

            <div class="col-span-2 p-6 bg-white rounded">
                <h2 class="text-lg">Домены</h2>
                <div class="grid grid-cols-2">
                    <strong>Хост</strong>
                    <strong>По-умолчанию</strong>
                </div>
                <div class="grid grid-cols-2 border-t p-2 gap-2">
                    <span>{{ result.domains.host }}</span>
                    <span>{{ result.domains.isDefault }}</span>
                </div>
            </div>


            <pre class="col-span-full text-xs">{{result}}</pre>

        </div>

    </authenticated-layout>

</template>

<script>
import {Head, Link, useForm} from '@inertiajs/inertia-vue3';
import AuthenticatedLayout from '@/Layouts/Authenticated';
import Navigation from '@/Components/Navigation/User';
import VInput from "@/Components/Input";
import VToggle from "@/Components/Toggle";
import VButton from "@/Components/Button";
import moment from "moment";

export default {
    components: {
        Head, Link,
        AuthenticatedLayout,
        Navigation,
        VInput,
        VToggle,
        VButton,
    },
    props: {
        notifications: Object,
        partnerId: String,
        result: Object,
    },
    data () {
        return {
            referralEmail: '',
        }
    },
    methods: {
        moment,
    },
}
</script>
